import { deviceManager } from "../../device/device_manager"

export const handleVersion = async() => {
    return deviceManager.deviceDriver.getVersion()
}
